import {get, sync} from "vuex-pathify";

export default {
    methods: {
        componentBeforeCreate() {
            this.step_mounted_status = false
        },
        componentCreated() {
            this.$store.set('func_data/match_token', this.$store.get('general_data/match_token'))
            // Block browser back button
            history.pushState(null, document.title, location.href);
            window.addEventListener('popstate', (event) => {
                history.pushState(null, document.title, location.href);
            });

            this.step_before_mount_status = false;
            if (_.isNull(this.step._before_mount)) {
                this.step_before_mount_status = true;
                return;
            }

            Promise.resolve(this.step._before_mount()).then(() => {
                this.step_before_mount_status = true
            })

        },
        componentMounted() {
            if (this.step._last) {
                setTimeout( ()=> {
                    console.log('mixin')
                    this.$store.dispatch('form/clear').then(()=>{
                        this.step_mounted_status = true
                    })
                }, 100);
            }else{
                this.step_mounted_status = true
            }
        },
    },
    computed: {
        currentStepName() {
            return this.$route.params.step
        },
        form: get('form/form'),
        step: get('form/form@_steps.:currentStepName'),
        active_component() {
            return _.get(this.step, '_component', null);
        },
        step_mounted_status: sync('func_data/step_mounted_status'),
        step_before_mount_status: sync('func_data/step_before_mount_status'),
    },
}
